import * as React from 'react';
import { useBOMStore } from 'src/hooks/bom';
import useReduxState from 'src/hooks/useReduxState';

const BomEditSubmitButton = (props) => {

    const [{ }, { }, { edit_bom_name }] = useBOMStore();

    const { editData } = props

    const [isEdit, setIsEdit] = useReduxState(false, 'setIsEdit');

    const onSubmitEdit = async (editData) => {
        await edit_bom_name(editData).then((res) => {
            if(res) {
                setIsEdit(false);
                //by Ramya Kannan (Rename BOM - Adobe script)
                localStorage.setItem("adobeEventType","renameBom");
            }
        })
    };
  
    return (
        <>
            <button className="bs5 btn btn-secondary w80 mx-3"
                onClick={() => onSubmitEdit(editData)}>save</button>
        </>
    );
}

export default BomEditSubmitButton;